/** Reviewed duplicate captures, keyed by exact public identity, never title. */
const PUBLIC_TEMPLATE_ALIASES: Readonly<Record<string, string>> = {
  // Same Memrise design, visible text and nine image sources; only capture
  // tracking URLs and an inherited-link style differ. Reviewed 2026-09-28.
  pt1_k97y763pqzmn855a4w02f9tkh98e35vc: 'pt1_k97qmwcvnc9zjw5a0g1jw2510n8ewrfy',
}

/**
 * A reviewed duplicate capture. Lists drop it and its URL redirects to the
 * canonical; it never borrows the canonical's identity, so a row's title,
 * preview and HTML always come from the same capture.
 */
export function isReviewedTemplateAlias(reference: string): boolean {
  return Object.hasOwn(PUBLIC_TEMPLATE_ALIASES, reference)
}

export function canonicalPublicTemplateReference(reference: string): string {
  return Object.hasOwn(PUBLIC_TEMPLATE_ALIASES, reference)
    ? PUBLIC_TEMPLATE_ALIASES[reference]
    : reference
}
